var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1612_5950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 0C3.58169 0 0 3.58169 0 7.99995C0 12.4182 3.58169 16 7.99995 16C12.4182 16 16 12.4182 16 7.99995C15.9951 3.58374 12.4163 0.00498045 7.99995 0V0ZM7.99995 15.1999C4.02349 15.1999 0.799951 11.9764 0.799951 7.99995C0.799951 4.02349 4.02349 0.799951 7.99995 0.799951C11.9764 0.799951 15.1999 4.02349 15.1999 7.99995C15.1954 11.9745 11.9745 15.1954 7.99995 15.1999Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06196 4.89895C6.89555 4.75349 6.64287 4.77048 6.49741 4.93674C6.3521 5.10315 6.36909 5.35583 6.53535 5.50129L9.39121 8.00002L6.5352 10.4989C6.3688 10.6444 6.35195 10.897 6.49726 11.0633C6.64272 11.2297 6.89541 11.2467 7.06181 11.1012L10.2618 8.30119C10.3486 8.22532 10.3984 8.11545 10.3984 8.00002C10.3984 7.88459 10.3486 7.77488 10.2618 7.69885L7.06196 4.89895Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1612_5950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron_right.13e283fd.svg";
export { ForwardRef as ReactComponent };